<!--tabItem 2020/03/13 Sunanguang-->
<template>
  <el-carousel class="its-carousel" :height="height" :autoplay="false" ref="tabCarousel" :loop="true" @change="tabChange">
    <el-carousel-item v-for="(tab,i) in tabs" :key="i">
      <div class="its-tab-container" :class="'its-tab-' + tab.id">
        <div class="its-tab-left">
          <div class="its-computer">
            <el-carousel class="its-carousel-child" :height="heights[i]" :autoplay="true" :loop="true">
              <el-carousel-item v-for="(img,i) in tab.item.images" :key="i">
                <img v-if="typeof img === 'string'" :src="getSrc(img)">
                <img v-else :src="getSrc(img.src)" :width="img.width + 'px'" :height="img.height + 'px'">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="its-tab-right">
          <p class="its-tab-title">{{tab.mainTitle}}</p>
          <p class="its-tab-desc" v-html="tab.item.desc"></p>
          <div class="its-tab-option">
            <div class="its-tab-code-container">
              <q-r-code v-if="tab.item.code" class="its-qr-code" :qr-url='tab.item.qrcodeUrl' :qr-size='140' :qrcodeId="tab.item.key + 1"></q-r-code>
              <img v-else-if="tab.item.identity==='WECHAT'" class="its-qr-code" src="../../../../assets/images/download/code.png">
            </div>
            <div class="its-btn" @click="downloadFile(tab.item)" v-html="tab.item.btn"></div>
          </div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import QRCode from '../../../../components/QRCode'
export default {
  name: 'DownloadTabItem',
  components: {
    QRCode
  },
  props: {
    tabs: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      height: '',
      heights: ['420px', '420px', '420px', '420px']
    }
  },
  mounted() {
    this.height = '559px'
  },
  methods: {
    setActiveTab: function (index) {
      this.$refs.tabCarousel.setActiveItem(index)
    },
    getSrc: function (img) {
      if (img.indexOf('/') === -1) {
        return require('@/assets/images/download/' + img)
      } else {
        return require('@/assets/images/' + img)
      }
    },
    downloadFile: function (item) {
      if (!item.download) {
        return
      }
      window.location.href = item.downloadUrl
    },
    setActiveItem: function (i) {
      this.$refs.tabCarousel.setActiveItem(i)
    },
    tabChange: function (index) {
      this.$emit('change-tab', index)
    }
  }
}
</script>
<style scoped>
.its-carousel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  /* height: 554px; */
  width: 1200px;
  margin: 0 auto;
}
.its-tab-container {
  height: 559px;
  position: relative;
  z-index: 2;
  width: 1200px;
  margin: 0 auto;
}
.its-carousel >>> .el-carousel__indicators {
  display: none;
}
.its-tab-item {
  position: absolute;
  width: 1200px;
  margin: 0 auto;
  height: 506px;
  top: 50%;
  margin-top: -253px;
  left: 0;
  right: 0;
}
.tab-shink {
  background-color: #f5f9ff;
}
.its-item {
  width: calc(100% - 690px);
  display: inline-block;
  position: absolute;
  padding: 0 20px 0 0;
  z-index: 1;
}
.right .its-item {
  left: 690px;
}
.left .its-item {
  left: 10px;
}
.its-item-1 .its-item {
  margin-top: 83px;
  padding-left: 10px;
}
.its-item-2 .its-item {
  margin-top: 80px;
}
.its-item-2 .its-banner {
  top: 43px !important;
}
.its-item-3 .its-item {
  margin-top: 82px;
}
.its-item-3 .its-banner {
  top: 42.5px !important;
}
.its-desc-items .its-desc {
  font-size: 22px;
  color: #404857;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 55px;
}

.its-sub-desc {
  color: #666666;
  font-size: 16px;
  margin-top: 20px;
}

.its-desc-items .its-desc span {
  margin-right: 13px;
  font-size: 12px;
  vertical-align: middle;
}
.its-banner {
  position: absolute;
  top: 0px;
}
.its-tab-item.left .its-banner {
  right: 0px;
}
.its-tab-item.right .its-banner {
  left: 0px;
}
.its-btn {
  cursor: pointer;
  height: 58px;
  line-height: 58px;
  display: inline-block;
  padding: 0 28px;
  border-radius: 26px;
  background-color: white;
  color: #588bf6;
  font-size: 20px;
  min-width: 260px;
  text-align: center;
}

.its-btn >>> i {
  font-size: 18px;
  margin-right: 5px;
}

.its-qr-code {
  width: 140px !important;
  height: 140px !important;
  position: absolute;
  left: 10px;
  top: 10px;
}
</style>

<style scoped>
.its-tab-container::after {
  clear: both;
  content: "";
  display: block;
}

.its-tab-container .its-tab-left {
  float: left;
  width: calc(100% - 563px);
}

.its-tab-container .its-tab-right {
  float: right;
  width: 563px;
}

.its-tab-desc {
  font-size: 18px;
  color: white;
  line-height: 2;
  width: 387px;
}

.its-tab-title {
  font-size: 36px;
  color: white;
}

.its-tab-1 .its-computer {
  width: 546px;
  height: 378px;
  background-image: url(../../../../assets/images/home/computer.png);
  background-size: 546px 378px;
  margin-left: 53px;
  margin-top: 67px;
}

.its-tab-1 .its-carousel-child {
  width: 496px;
  padding-top: 24px;
  margin-left: 26px;
}

.its-tab-1 .its-tab-title {
  margin-left: 50px;
  margin-top: 105px;
}

.its-tab-1 .its-tab-desc {
  margin-left: 50px;
  margin-top: 25px;
}

.its-tab-1 .its-btn {
  margin-left: 50px;
  margin-top: 32px;
}

.its-tab-2 .its-computer {
  width: 235px;
  height: 451px;
  background-image: url(../../../../assets/images/download/phone1.png);
  background-size: 235px 451px;
  margin-left: 153px;
  margin-top: 36px;
}

.its-tab-2 .its-tab-left {
  width: 385px;
}

.its-tab-2 .its-tab-right {
  width: calc(100% - 385px);
}

.its-tab-2 .its-carousel-child {
  width: 203px;
  padding-top: 21px;
  margin-left: 17px;
}

.its-tab-2 .its-tab-title {
  margin-left: 92px;
  margin-top: 90px;
}

.its-tab-2 .its-tab-desc {
  margin-left: 92px;
  margin-top: 25px;
  width: 560px;
}

.its-tab-2 .its-btn {
  margin-left: 30px;
  margin-top: 50px;
  position: absolute;
}

.its-tab-2 .its-tab-option {
  margin-top: 38px;
  margin-left: 92px;
}

.its-tab-2 .its-tab-code-container,
.its-tab-3 .its-tab-code-container,
.its-tab-4 .its-tab-code-container {
  width: 160px;
  height: 160px;
  position: relative;
  display: inline-block;
  background-color: white;
}

.its-tab-3 .its-computer {
  width: 497px;
  height: 329px;
  background-image: url(../../../../assets/images/download/pad.png);
  background-size: 497px 329px;
  margin-left: 89px;
  margin-top: 102px;
}

.its-tab-3 .its-tab-left {
  width: 586px;
}

.its-tab-3 .its-tab-right {
  width: calc(100% - 586px);
}

.its-tab-3 .its-carousel-child {
  width: 464px;
  padding-top: 10px;
  margin-left: 17px;
}

.its-tab-3 .its-tab-title {
  margin-left: 92px;
  margin-top: 102px;
}

.its-tab-3 .its-tab-desc {
  margin-left: 92px;
  margin-top: 25px;
  width: 560px;
}

.its-tab-3 .its-btn {
  margin-left: 30px;
  margin-top: 50px;
  position: absolute;
}

.its-tab-3 .its-tab-option {
  margin-top: 16px;
  margin-left: 92px;
}

.its-tab-4 .its-computer {
  width: 235px;
  height: 451px;
  background-image: url(../../../../assets/images/download/phone2.png);
  background-size: 235px 451px;
  margin-left: 153px;
  margin-top: 36px;
}

.its-tab-4 .its-tab-left {
  width: 385px;
}

.its-tab-4 .its-tab-right {
  width: calc(100% - 385px);
}

.its-tab-4 .its-carousel-child {
  width: 197px;
  padding-top: 21px;
  margin-left: 19px;
}

.its-tab-4 .its-tab-title {
  margin-left: 92px;
  margin-top: 90px;
}

.its-tab-4 .its-tab-desc {
  margin-left: 92px;
  margin-top: 25px;
  width: 560px;
}

.its-tab-4 .its-btn {
  margin-left: 30px;
  margin-top: 50px;
  position: absolute;
}

.its-tab-4 .its-tab-option {
  margin-top: 38px;
  margin-left: 92px;
}

.its-tab-code-container >>> .qrcode_box canvas {
  width: 140px;
  height: 140px;
}

.its-carousel >>> .el-carousel__arrow {
  width: 52px;
  height: 52px;
  background-color: transparent;
  border: 2px solid white;
  color: white;
}

.its-carousel >>> .el-carousel__arrow i {
  font-size: 26px;
  font-weight: 600;
}

.its-carousel >>> .el-carousel__arrow--left {
  left: 0;
}

.its-carousel >>> .el-carousel__arrow--right {
  right: 0;
}

.its-carousel-child >>> .el-carousel__arrow {
  display: none !important;
}
</style>
